import { Box } from '@mui/material'
import React from 'react'

import FilterSelect from './FilterSelect'
import SortSelect from './SortSelect'

const SelectBox: React.FC = () => {
  return (
    <Box alignItems="center" display="flex" flexDirection="row" justifyContent="flex-start" marginX={0.5}>
      <Box marginX={0.5} style={{ zoom: 0.75 }}>
        <FilterSelect />
      </Box>
      <Box marginX={0.5} style={{ zoom: 0.75 }}>
        <SortSelect />
      </Box>
    </Box>
  )
}

export default SelectBox
